document.addEventListener('click', async (event) => {
    const link = event.target.closest('a');
    if (!link || link.hash !== '#open-chat') return;
    try {
        // remark is lazyloaded, loadRemark() resolves once the sdk is ready
        if (typeof window.remark !== 'function') await window.loadRemark();
        window.remark('open');
    } catch (e) {
        console.warn('remark chat is not available', e);
    }
});
